import { Card, CardContent, CardFooter } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

export function ReviewSkeleton() {
  return (
    <Card className="flex w-full h-full min-h-0 flex-col overflow-hidden bg-primary-background pt-2 sm:pt-5 sm:mx-auto sm:max-w-4xl sm:rounded-2xl sm:h-fit sm:shadow-lg">
      {/* 헤더 */}
      <div className="flex items-center justify-between px-5">
        <Skeleton className="size-8 rounded-lg" />
        <Skeleton className="h-8 w-24" />
        <Skeleton className="size-8 rounded-lg" />
      </div>

      {/* 본문 */}
      <CardContent className="flex flex-1 min-h-0 flex-col items-center gap-6 px-5 sm:px-4 sm:aspect-video sm:max-h-fit">
        {/* 단어 카드 */}
        <Skeleton className="h-40 w-full rounded-xl" />

        {/* 옵션 4개 */}
        <div className="w-full grid grid-cols-1 sm:grid-cols-2 gap-3">
          {Array.from({ length: 4 }, (_, i) => (
            <Skeleton key={i} className="h-17 w-full rounded-xl" />
          ))}
        </div>
      </CardContent>

      {/* 푸터 */}
      <CardFooter className="flex items-center justify-center border-t-0 p-5 pb-6 bg-transparent">
        <Skeleton className="h-12 w-32 rounded-md" />
      </CardFooter>
    </Card>
  );
}
